// removed by extract-text-webpack-plugin
module.exports = {"BackButtonWrapper":"BackButtonWrapper__rhK0J","HeaderContainer":"HeaderContainer__9U8ZH","CompanyName":"CompanyName__3y6ae","HelpDesk":"HelpDesk__17X91","InputSearch":"InputSearch__2pcBb","InputWrapper":"InputWrapper__3f31f","SearchIcon":"SearchIcon__2sj3O"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/Header/style.scss
// module id = kfHX
// module chunks = 0